import { useSelector } from 'react-redux';
import { getSeasonalIllustrationSrc } from '../../utils/seasonalIllustration';

/** 内嵌在顶栏搜索框右侧的四季插画（浅色日间 / 深色夜间包） */
const NavbarSeasonIllustration = () => {
	const isDark = useSelector((state) => Boolean(state.config?.isDark));
	const src = getSeasonalIllustrationSrc(new Date(), { isDark });

	return (
		<span className='search-box__season' aria-hidden='true'>
			<img src={src} alt='' className='search-box__season-img' draggable={false} />
		</span>
	);
};

export default NavbarSeasonIllustration;
